const route = {
  home: '/',
  following: '/following',
  setting: '/setting',
  upload: '/upload',
  explore: '/explore',
  friends: '/friends',
  inbox: '/inbox',
  messages: '/messages',
  live: '/live',
  profile: '/user/:nickname',
  resetPassword: '/reset-password',
  coins: '/coins',
  creator: '/creator',
  feedback: '/feedback',
};

export default route;
